import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { TabProvider } from "./context/TabContext";
import { Toaster } from "react-hot-toast";
import { globalStyles } from "./utils/theme";
import PropTypes from "prop-types";
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import '../src/cssFiles/CommonStyles/Common.css';
import '../src/cssFiles/CommonStyles/Responsiveness.css';

import { getToken, getIsAdminLogin } from "./utils/Common";

import Login from './pages/Login/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import EventsCalendar from "./pages/EventsCalendar/EventsCalendar";
import Payroll from "./pages/Payroll/Payroll";
import Payslip from "./pages/Payroll/Payslip";
import GeneratePayroll from "./pages/Payroll/GeneratePayroll";
import ThirteenthMonth from "./pages/Reports/ThirteenthMonth";
import Timesheet from "./pages/Timesheet/Timesheet";
import UploadTimesheet from "./pages/Timesheet/UploadTimesheet";
import Memorandum from "./pages/Memorandum/Memorandum";
import ViewMemorandum from "./pages/Memorandum/ViewMemorandum";
import Announcement from "./pages/Announcement/Announcement";
import ViewAnnouncement from "./pages/Announcement/ViewAnnouncement";
import CommunicationLetter from "./pages/CommunicationLetter/CommunicationLetter";
import ViewCommunicationLetter from "./pages/CommunicationLetter/ViewCommunicationLetter";
import Leave from "./pages/Leave/Leave";
import ViewLeave from "./pages/Leave/ViewLeave";
import Overtime from "./pages/Overtime/Overtime";
import EvaluationForm from "./pages/Form/EvaluationForm";
import EvaluationFormInputPage from "./pages/Form/EvaluationFormInputPage";
import PerformanceEvalutaion from "./pages/Reports/PerformanceEvaluation";
import Loan from "./pages/Loan/Loan";
import ViewLoan from "./pages/Loan/ViewLoan";

// Contribution Report
import PhicContributionReport from "./pages/PhicContributionReport/PhicContributionReport";
import ViewEmployeePhicContribution from "./pages/PhicContributionReport/ViewEmployeePhicContribution";
import PrintPhicContributionReport from "./pages/PhicContributionReport/PrintPhicContributionReport";
import SssContributionReport from "./pages/SssContributionReport/SssContributionReport";
import ViewEmployeeSssContribution from "./pages/SssContributionReport/ViewEmployeeSssContribution";
import PrintSssContributionReport from "./pages/SssContributionReport/PrintSssContributionReport";
import HdmfContributionReport from "./pages/HdmfContributionReport/HdmfContributionReport";
import ViewEmployeeHdmfContribution from "./pages/HdmfContributionReport/ViewEmployeeHdmfContribution";
import PrintHdmfContributionReport from "./pages/HdmfContributionReport/PrintHdmfContributionReport";

// Manage Employee Modules
import Employee from "./pages/Employee/Employee";
import EmployeeProfile from "./pages/Employee/EmployeeProfile";
import EmployeeHistoryReport from "./pages/Employee/EmployeeHistoryReport";
import LeaveCredit from "./pages/Reports/LeaveCredit";

// Manage Systems
import LetterType from "./pages/LetterType/LetterType";
import Position from "./pages/Position/Position";
import Project from "./pages/Project/Project";
import Holiday from "./pages/Holiday/Holiday";

const ProtectedRoute = ({element, condition}) => {
  return condition ? element : <Login/>
}
ProtectedRoute.propTypes = {
  element: PropTypes.node,
  condition: PropTypes.bool,
}


export default function App() {
  const userToken = getToken();
  const isAdminLogin = getIsAdminLogin();
  
  return (
    <div>
      <TabProvider>
      <Toaster 
        position="top-right" 
        reverseOrder={false} 
        toastOptions={{
          style:{
            fontFamily: globalStyles.fontRegular,
            textTransform: 'capitalize'
          }
        }}
      />
      <Router>
      <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/dashboard" element={<ProtectedRoute element={<Dashboard />} condition={userToken} />} />
      <Route path="/dashboard/eventscalendar" element={<ProtectedRoute element={<EventsCalendar />} condition={userToken} />} />
      <Route path="/payrolls" element={<ProtectedRoute element={<Payroll />} condition={userToken} />} />
      <Route path="/payrolls/generate" element={<ProtectedRoute element={<GeneratePayroll />} condition={userToken && isAdminLogin} />} />
      <Route path="/payrolls/payslip/:id" element={<ProtectedRoute element={<Payslip />} condition={userToken} />} />
      <Route path="/thirteenth-month-report" element={<ProtectedRoute element={<ThirteenthMonth />} condition={userToken} />} />
      <Route path="/timesheet" element={<ProtectedRoute element={<Timesheet />} condition={userToken} />} />
      <Route path="/timesheet/upload" element={<ProtectedRoute element={<UploadTimesheet />} condition={userToken} />} />
      <Route path="/memorandums" element={<ProtectedRoute element={<Memorandum />} condition={userToken} />} />
      <Route path="/memorandums/view" element={<ProtectedRoute element={<ViewMemorandum />} condition={userToken} />} />
      <Route path="/announcements" element={<ProtectedRoute element={<Announcement />} condition={userToken} />} />
      <Route path="/announcements/view" element={<ProtectedRoute element={<ViewAnnouncement />} condition={userToken} />} />
      <Route path="/communication-letters" element={<ProtectedRoute element={<CommunicationLetter />} condition={userToken} />} />
      <Route path="/communication-letters/view" element={<ProtectedRoute element={<ViewCommunicationLetter />} condition={userToken} />} />
      <Route path="/communication-letters/view/:passedId" element={<ProtectedRoute element={<ViewCommunicationLetter />} condition={userToken} />} />
      <Route path="/leaves" element={<ProtectedRoute element={<Leave />} condition={userToken} />} />
      <Route path="/overtimes" element={<ProtectedRoute element={<Overtime />} condition={userToken} />} />
      <Route path="/leaves/view" element={<ProtectedRoute element={<ViewLeave />} condition={userToken} />} />
      <Route path="/evaluation-forms" element={<ProtectedRoute element={<EvaluationForm />} condition={userToken} />} />
      <Route path="/evaluation-forms/form-page" element={<ProtectedRoute element={<EvaluationFormInputPage />} condition={userToken} />} />
      <Route path="/loans" element={<ProtectedRoute element={<Loan />} condition={userToken} />} />
      <Route path="/loans/view" element={<ProtectedRoute element={<ViewLoan />} condition={userToken} />} />
      <Route path="/performance-evaluation" element={<ProtectedRoute element={<PerformanceEvalutaion />} condition={userToken} />} />

      {/* CONTRIBUTION REPORTS */}
      <Route path="/phic-contribution-report" element={<ProtectedRoute element={<PhicContributionReport />} condition={userToken} />} />
      <Route path="/phic-contribution-report/view" element={<ProtectedRoute element={<ViewEmployeePhicContribution />} condition={userToken} />} />
      <Route path="/phic-contribution-report/print-report" element={<ProtectedRoute element={<PrintPhicContributionReport />} condition={userToken} />} />
      <Route path="/sss-contribution-report" element={<ProtectedRoute element={<SssContributionReport />} condition={userToken} />} />
      <Route path="/sss-contribution-report/view" element={<ProtectedRoute element={<ViewEmployeeSssContribution />} condition={userToken} />} />
      <Route path="/sss-contribution-report/print-report" element={<ProtectedRoute element={<PrintSssContributionReport />} condition={userToken} />} />
      <Route path="/hdmf-contribution-report" element={<ProtectedRoute element={<HdmfContributionReport />} condition={userToken} />} />
      <Route path="/hdmf-contribution-report/view" element={<ProtectedRoute element={<ViewEmployeeHdmfContribution />} condition={userToken} />} />
      <Route path="/hdmf-contribution-report/print-report" element={<ProtectedRoute element={<PrintHdmfContributionReport />} condition={userToken} />} />

      {/* MANAGE EMPLOYEE MODULES */}
      <Route path="/employees" element={<ProtectedRoute element={<Employee />} condition={userToken} />} />
      <Route path="/employees/view/:id" element={<ProtectedRoute element={<EmployeeProfile />} condition={userToken} />} />
      <Route path="/employees/history-report" element={<ProtectedRoute element={<EmployeeHistoryReport />} condition={userToken} />} />
      <Route path="/leave-credits" element={<ProtectedRoute element={<LeaveCredit />} condition={userToken} />} />

      {/* MANAGE SYSTEMS */}
      <Route path="/letter-types" element={<ProtectedRoute element={<LetterType />} condition={userToken && isAdminLogin} />} />
      <Route path="/positions" element={<ProtectedRoute element={<Position />} condition={userToken && isAdminLogin} />} />
      <Route path="/projects" element={<ProtectedRoute element={<Project />} condition={userToken && isAdminLogin} />} />
      <Route path="/holidays" element={<ProtectedRoute element={<Holiday />} condition={userToken && isAdminLogin} />} />
    </Routes>
      </Router>
      </TabProvider>
    </div>
  );
}
